import z from "zod";
import { AuditMetaSchema } from "./auditMetaTypes";
import { GrantsSchema } from "./grantsTypes";
import { AssetIdSchema, ConceptIdSchema, LabelIdSchema, ViewIdSchema } from "./idTypes";
import { TenancySchema } from "./tenancyTypes";

export const FilterOperatorSchema = z.enum(["and", "or", "nand", "nor"]);
export type FilterOperator = z.infer<typeof FilterOperatorSchema>;

const FilterSchema = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("asset"),
    id: AssetIdSchema,
    operator: FilterOperatorSchema,
  }),
  z.object({
    kind: z.literal("concept"),
    id: ConceptIdSchema,
    operator: FilterOperatorSchema,
  }),
  z.object({
    kind: z.literal("label"),
    id: LabelIdSchema,
    operator: FilterOperatorSchema,
  }),
]);

export const FilterGroupSchema = z.object({
  group: z.array(FilterSchema),
  operator: FilterOperatorSchema,
});
export type FilterGroup = z.infer<typeof FilterGroupSchema>;

export const FilterGroupsSchema = z.array(FilterGroupSchema);
export type FilterGroups = z.infer<typeof FilterGroupsSchema>;

export const ViewSchema = z
  .object({
    id: ViewIdSchema,
    name: z.string(),
    description: z.string(),
    filters: FilterGroupsSchema,
    grants: GrantsSchema,
  })
  .extend(TenancySchema.shape)
  .extend(AuditMetaSchema.shape);
export type View = z.infer<typeof ViewSchema>;
